<template>
    <div class="user-card">
        <div>
            <van-skeleton title avatar :row="2" v-if="userInfo==''"/>
            <template v-else>
                <div>
                    <img :src="userInfo.avatarurl" alt="">
                    <div>
                        <span>{{userInfo.nickname}}</span>
                        <span>{{userInfo.gender*1===1?'男':'女'}}</span>
                    </div>
                </div>
                <div>
                    <span>金币记录 ></span>
                    <div @click="goCoinRecord"><span>{{userInfo.totalpoint}}</span>个金币</div>
                </div>
            </template>
        </div>
        <div>
            金币不够花?点击 <span @click="goHome" class="mvbutton small">活动专区</span>,赚取金币吧!
        </div>
    </div>
</template>
<script>
    import './index.less'
    export default {
        name: "UserCard",
        computed: {},
        data() {
            return {
                userInfo: ""
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getUserInfo();
            })
        },
        methods: {
            goCoinRecord()
            {
                this.$router.push({name: "coinRecord"});
            },
            goHome() {
                this.$router.push({name: "exchange"});
            },
            getUserInfo() {
                this.$api.user.getUserInfo().then((res) => {
                    if (res.status * 1 === 200) {
                        this.userInfo = res.data
                    }
                })
            }
        }
    }
</script>
